// components
import { queries } from 'RestAPIs/rapini';
import { LogEntry } from './components/LogEntry';

// styles
import { LogEntriesContainer } from './components/LogEntry.styles';

// types
import { AuditedCommandChangeEventDetailsResponse } from 'generated/index';

// utils
import dayjs from 'dayjs';

export const LogPanel = () => {
  const { data: auditedCommands } = queries.useFindAuditedCommands(
    dayjs().startOf('day').toISOString(),
    dayjs().endOf('day').toISOString()
  );

  const undoCommandMap = new Map<
    string,
    AuditedCommandChangeEventDetailsResponse
  >();
  (auditedCommands?.commands || [])
    .filter((command) => command.type === 'UndoCommand')
    .forEach((undoCommand) => {
      const targetCommandId = undoCommand.commandDetails?.commandId;
      if (targetCommandId) {
        undoCommandMap.set(targetCommandId, undoCommand);
      }
    });

  // Filter out UndoCommands - they'll be displayed within their original command
  const displayCommands = (auditedCommands?.commands || []).filter(
    (command) => command.type !== 'UndoCommand'
  );

  // Find the first undoable command (not undone)
  const firstUndoableCommandIndex = displayCommands.findIndex(
    (command) => !undoCommandMap.has(command.commandId || '')
  );

  return (
    <LogEntriesContainer>
      {displayCommands.map((command, index) => {
        const isFirst = index === firstUndoableCommandIndex;
        const undoCommand = command.commandId
          ? undoCommandMap.get(command.commandId)
          : undefined;

        return (
          <LogEntry
            key={index}
            command={command}
            isFirst={isFirst}
            undoCommand={undoCommand}
          />
        );
      })}
    </LogEntriesContainer>
  );
};
